import React, { useEffect, useRef, useState } from 'react'
import { Accordion, Container, Row } from 'react-bootstrap'
import { PrintedCertificatesVM } from '../../Structure/ViewModels/Printing/printedCertificatesVM'
import Search from '../Utilities/Search'


const PrintedCertificates = () => {
  const [vm,setVm] = useState<{viewModel:PrintedCertificatesVM}>({viewModel:new PrintedCertificatesVM()})
  const control = vm.viewModel 
  useEffect(()=>{
    control.subscribeUpdate(setVm)
    control.getData()
  },[])

  const [finishedPaths , setFinishedPaths] = useState(false)
  const [finishedCourses , setFinishedCourses] = useState(false)

  const [pathsSearch, setPathsSearch] = useState('')

  const [coursesSearch, setCoursesSearch] = useState('')

  useEffect(() => {
    const handleScroll = () => {
        const elementCourses = scrollableRefCourses.current;
        if (elementCourses && elementCourses.scrollTop + elementCourses.clientHeight >= elementCourses.scrollHeight) {
          if(!finishedCourses){
            
            const id = control.Courses.reduce((min,obj)=>{
              return obj.id < min.id ? obj:min;
            },control.Courses[0]).id
            control.getMoreCourses({id:id , search:pathsSearch , initial:false}).then(a=>{
              setFinishedCourses(!a)
            })
          }
        }
    };

    const elementCourses = scrollableRefCourses.current;
    if (elementCourses) {
        elementCourses.addEventListener('scroll', handleScroll);
    }

    return () => {
        if (elementCourses) {
            elementCourses.removeEventListener('scroll', handleScroll);
        }
    };
}, [coursesSearch]);

useEffect(() => {
  const handleScrollPaths = () => {
      const elementPaths = scrollableRefPaths.current;
      if (elementPaths && elementPaths.scrollTop + elementPaths.clientHeight >= elementPaths.scrollHeight) {
          if(!finishedPaths){
            const id = control.Paths.reduce((min,obj)=>{
              return obj.id < min.id ? obj:min;
            },control.Paths[0]).id
            control.getMorePrintedPaths({id:id , search:pathsSearch , initial:false}).then(a=>{
              setFinishedPaths(!a)
            })
          }
        
      }
  };

  const elementPaths = scrollableRefPaths.current;
  if (elementPaths) {
      elementPaths.addEventListener('scroll', handleScrollPaths);
  }

  return () => {
      if (elementPaths) {
          elementPaths.removeEventListener('scroll', handleScrollPaths);
      }
  };
}, [pathsSearch]);

const scrollableRefCourses = useRef<HTMLDivElement | null>(null);
const scrollableRefPaths = useRef<HTMLDivElement | null>(null);

  const pathsSearchAction = (value:string)=>{
    setPathsSearch(value); 
    control.getMorePrintedPaths({search:value, initial:true})
    setFinishedPaths(false) 
  }
  const coursesSearchAction = (value:string)=>{
    setCoursesSearch(value); 
    control.getMoreCourses({search:value, initial:true})
    setFinishedCourses(false) 
  }

  return (
    <Container>
        <Accordion defaultActiveKey={'0'} className='w-100 rounded-0 py-3' style={{outline:'none' , borderRadius:'0px'}}>
          <Accordion.Item eventKey='1' className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}} >
            <Accordion.Button  className='border-0 border-bottom' style={{outline:'none', border:'none' , borderRadius:'0px', boxShadow:'none'}}>
              <h5 className='ps-3 px-2'>المسارات</h5>
            </Accordion.Button>
            <Accordion.Body>
              <div className='d-flex justify-content-end px-4'>
                <div>
                  <Search
                    hasNoSelect
                    onSearch={

                      pathsSearchAction
                    }
                  />
                </div>
              </div>
              <div  ref={scrollableRefPaths} className='px-0 px-lg-3 overflow-y-auto' style={{height:'500px'}}>
                <div className='d-flex p-3 overflow-x-auto'>
                  <table className='w-100 text-center' style={{minWidth:'800px'}}>
                      <tr className='txt-color-I bg-light-gray'>
                          <th>الاسم</th>
                          <th>المسار</th>
                          <th>الكود</th>
                          <th>من</th>
                          <th>الى</th>
                          <th>الساعات</th>
                          <th>الجهة</th>
                          <th>ملاحظات</th>
                          <th>توثيق</th>
                          <th>التاريخ</th>
                      </tr>
                      {
                      control.Paths.map((item,index)=>(
                          <tr key={index} style={{background:index%2?'white':'rgba(200,200,200,0.2)'}}>
                              <td>{item.trainee_name}<br/>{item.trainee_english_name}</td>
                              <td>{item.path}</td>
                              <td>{item.code}</td>
                              <td>{item.start}</td>
                              <td>{item.end}</td>
                              <td>{item.hours}</td>
                              <td>{item.institution}</td>
                              <td>{item.notes}</td>
                              <td>{item.verification==='verify'?'توثيق':'ــــ'}</td>
                              <td>{item.date}</td>
                          </tr>
                      ))
                      }
                  </table>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion> 

        <Accordion defaultActiveKey={'0'} className='w-100 rounded-0 py-3' style={{outline:'none' , borderRadius:'0px'}}>
          <Accordion.Item eventKey='1' className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}} >
            <Accordion.Button  className='border-0 border-bottom' style={{outline:'none', border:'none' , borderRadius:'0px', boxShadow:'none'}}>
              <h5 className='ps-3 px-2'>الكورسات</h5>
            </Accordion.Button>
            <Accordion.Body>
              <div className='d-flex justify-content-end px-4'>
                <div>
                  <Search
                    hasNoSelect
                    onSearch={

                      coursesSearchAction
                    }
                  />
                </div>
              </div>
           
              <div  ref={scrollableRefCourses} className='px-0 px-lg-3 overflow-y-auto' style={{height:'500px'}}>
                <div className='d-flex p-3 overflow-x-auto'>
                        <table className='w-100 text-center' style={{minWidth:'800px'}}>
                            <tr className='txt-color-I bg-light-gray'>
                                <th>الاسم</th>
                                
                                <th>الكورس</th>
                                <th>الكود</th>
                                <th>من</th>
                                <th> الى</th>
                                <th>الساعات</th>
                                <th>الجهة</th>
                                <th>ملاحظات</th>
                                <th>التاريخ</th>
                            </tr>
                            {
                            control.Courses.map((item,index)=>(
                                <tr key={index} style={{background:index%2?'white':'rgba(200,200,200,0.2)'}}>
                                    <td>{item.trainee_name}<br/>{item.trainee_english_name}</td>
                                    <td>{item.course}</td>
                                    <td>{item.code}</td>
                                    <td>{item.start}</td>
                                    <td>{item.end}</td>
                                    <td>{item.hours}</td>
                                    <td>{item.institution}</td>
                                    <td>{item.notes}</td>
                                    <td>{item.date}</td>
                                </tr>
                            ))
                            }
                        </table>
                    </div>
                    </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion> 
    </Container>
  )
}

export default PrintedCertificates
